

export enum PayoutStatusColor {
    '#F68A5B',
    '#F7C16A',
    '#2BA885',
    '#C4C4C4',
}

